import { DashboardRepository } from '../repositories'

export interface StatisticsBo extends DashboardRepository.StatisticsRespDto {}

/** 取得統計資料 */
export async function getStatistics(): Promise<StatisticsBo> {
  const statisticsDto = await DashboardRepository.getStatistics()

  return statisticsDto
}
